// extracted by mini-css-extract-plugin
module.exports = {"main-component":"emptyChatSection_main-component__1dNn4"};